<template>
  <footer class="footer">
    <p>&copy; {{msg}}</p>
  </footer>

</template>

<script>
  export default {
    name:"BottomBar",
    data(){
      return {
        msg:"2021 Company, Inc."
      }
    }
  }
</script>

<style>

</style>